"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var styles_1 = require("../../styles");
var TokenLogo_1 = __importDefault(require("./TokenLogo"));
var TokenName_1 = __importDefault(require("./TokenName"));
function TokenDisplay(_a) {
    var symbol = _a.symbol, logo = _a.logo, _b = _a.className, className = _b === void 0 ? "" : _b, reverse = _a.reverse, singleToken = _a.singleToken, hideSymbol = _a.hideSymbol, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)(StyledContainer, __assign({ className: "twap-token-display ".concat(className), onClick: onClick }, { children: reverse ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [singleToken && (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: "1" }), !hideSymbol && (0, jsx_runtime_1.jsx)(TokenName_1.default, { name: symbol }), (0, jsx_runtime_1.jsx)(TokenLogo_1.default, { logo: logo })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TokenLogo_1.default, { logo: logo }), singleToken && (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: "1" }), !hideSymbol && (0, jsx_runtime_1.jsx)(TokenName_1.default, { name: symbol })] })) })));
}
exports.default = TokenDisplay;
var StyledContainer = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    gap: 8,
    width: "fit-content",
});
